import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy, ElementRef, SimpleChanges, OnChanges } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { URL } from 'url';
import * as api from '../../shared/api/apihandler';
import { SubscriptionObject } from 'app/shared/models/standard.models';

@Component({
  selector: 'app-clear-price-search-v2',
  templateUrl: './clear-price-search-v2.component.html',
  styleUrls: ['./clear-price-search-v2.component.css']
})
export class ClearPriceSearchV2Component implements OnInit, OnDestroy, OnChanges {
  @Input('clicked') set chosen(p: boolean) {
    if (p) { this.searchValue = '' }
  };
  @Input('KlarPrisType') KlarprisAccountType: 'shop' | 'offers';
  @Input() KlarPrisAccount : string;
  @Input('caseId') caseId = null;
  @Output() product = new EventEmitter();
  @Output() KPResults = new EventEmitter();
  @Output() KlarPrisAccountChange = new EventEmitter<string>();
  hasKlarPris = false;
  KlarPrisAccountSetForOffers = false;
  KlarPrisAccountSetForPackages = false;
  products;
  KlarPrisClass = { 'doShow': false, 'dontShow': true }
  searchValue = '';
  standardAccount;
  searchAccount:string = null;
  clearPriceAccounts;
  productLineLength = '100%';

  spotProduct = {row:0,whole:-1};
  searchSubject = new Subject<string>();
  subs: SubscriptionObject = {};


  constructor(private httpClient: HttpClient,) { }

  ngOnInit() {
    this.getKpAccounts();
    this.klarprisSetupCheck();
    document.addEventListener('click', (e) => { this.clickedOutsideOutput(e) });
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.subs['searchSubscription'] = this.searchSubject
    .pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((searchTerm: string) => {
        if (!!this.caseId) {
          return this.httpClient.post(api.jubloApi + 'api/Website/OfferProductSearch/OfferCreator/' + this.caseId,
            {
              searchString: searchTerm,
              klarPrisAccount: this.searchAccount
            },
            { headers });
        } else {
          return this.httpClient.post(api.jubloApi + 'api/Website/OfferProductSearch/PackageCreator', { "searchString": this.searchValue }, { headers });
        }
      })
    )
    .subscribe(
      (result: Array<KlarprisResponse>) => {
        this.KPResults.emit(result.sort((a, b) => +a.number < +b.number ? -1 : 1));
        this.products = result.sort((a, b) => +a.number < +b.number ? -1 : 1);
      },
      fail => { },
      () => { }
    );
  }

  ngOnDestroy() {
    document.removeEventListener('click', (e) => { this.clickedOutsideOutput(e) });
    for(let x of Object.keys(this.subs)) this.subs[x].unsubscribe();
  }

  ngOnChanges(change: SimpleChanges) {
    if (!!change && !!change.KlarPrisAccount && change.KlarPrisAccount.currentValue != null) {
      this.searchAccount = change.KlarPrisAccount.currentValue;
    }
  }

  klarprisSetupCheck() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/PackageDistributor/PackageDistributorOffer', { headers }).subscribe((data: boolean) => {
      this.hasKlarPris = data;
    });
  }

  getOfferKlarPrisAccount() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/Settings/57E26240-F5AB-45EA-B605-2B72AE37C20E', { headers }).subscribe((result: KPOfferAccount) => {
      if (this.standardAccount.find(x => x.key == result.value) == null) { 
        this.updateDistributor("57E26240-F5AB-45EA-B605-2B72AE37C20E", this.standardAccount[0].key)
        this.searchAccount = this.standardAccount[0].key;
      }
      if (result.value != null) { 
        this.KlarPrisAccountSetForOffers = true;
        this.searchAccount = !this.searchAccount ? result.value : this.searchAccount;
      }
      else { this.updateDistributor("57E26240-F5AB-45EA-B605-2B72AE37C20E", this.standardAccount[0].value) }
    });
  }

  getPackageKlarPrisAccount() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/Settings/79F36B91-C4EE-4FE4-9872-1E70BF2E038D', { headers }).subscribe((data: any) => {
      if (this.standardAccount.find(x => x.key == data.value) == null) { this.updateDistributor("79F36B91-C4EE-4FE4-9872-1E70BF2E038D", this.standardAccount[0].key) }
      if (data != null) { this.KlarPrisAccountSetForPackages = true; }
      else { this.updateDistributor("79F36B91-C4EE-4FE4-9872-1E70BF2E038D", this.standardAccount[0].value) }
    });
  }

  getKpAccounts() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/KlarPris/GetAccounts', { headers }).subscribe((data: any) => {
      this.clearPriceAccounts = data;
      if (data != null) {
        this.standardAccount = data;
        this.getOfferKlarPrisAccount();
        this.getPackageKlarPrisAccount()
      }
    }, () => { });
  }

  getKPproduct() {
    if (this.searchValue != '') {
      this.searchSubject.next(this.searchValue)
    }
    else { this.closeResultBox() }
  }

  navigateResult(e){
    if( !!this.products && !!this.products.length && 
        (
          ['ArrowUp', 'ArrowLeft', 'ArrowRight', 'ArrowDown','Enter'].includes(e.code) || 
          ['ArrowUp', 'ArrowLeft', 'ArrowRight', 'ArrowDown','Enter'].includes(e.key) ||
          [ 38, 37 , 39 , 40 , 13 ].includes(e.keyCode)
        )
      ){
        e.preventDefault();
        switch(e.code){
          case 'ArrowUp' :{
            if(this.spotProduct.row > 0){ 
              this.spotProduct.row -= 1;
              this.spotProduct.whole = Math.min(this.spotProduct.whole, this.products[this.spotProduct.row].wholesaler.length - 1);
            }
            break
          }
          case 'ArrowDown' :{
            if(this.spotProduct.row < this.products.length - 1){ 
              this.spotProduct.row += 1; 
              this.spotProduct.whole = Math.min(this.spotProduct.whole, this.products[this.spotProduct.row].wholesaler.length - 1);
            }
            break
          }
          case 'ArrowLeft' :{
            if(this.spotProduct.whole > -1) this.spotProduct.whole -= 1;
            break
          }
          case 'ArrowRight' :{
            if(this.spotProduct.whole < this.products[this.spotProduct.row].wholesaler.length -1) this.spotProduct.whole += 1;
            break
          }
          case 'Enter' :{
            let p = this.products[this.spotProduct.row];
            if(this.spotProduct.whole == -1) {
              this.emitCheapestProduct(p, p.description);
              this.spotProduct = {row:0,whole:-1};
            }
            else {
              this.emitChosenProduct(p, p.wholesaler[this.spotProduct.whole]);
              this.spotProduct = {row:0,whole:-1};
            }
            break
          }
        }
      }
  }

  getProductLineLength(x) {
    let w = !!x ? 'calc(100% - ' + (4 * x.length == 4 ? 5 : 4 * x.length) + 'rem)': '100%';
    return w;
  }

  emitChosenProduct(i: KlarprisResponse, p: Product) {
    this.searchValue = ''; this.products = [];
    this.product.emit({
      number: i.number,
      description: i.description,
      wholesaler: p.wholesaler.key,
      image: i.image,
      quantity: 1,
      price: p.price,
      listPrice: p.listPrice,
      companyProduct: i.companyProduct,
      manufacturerLogo: i.manufacturerLogo,
      accountId: this.searchAccount
    });
  }

  emitCheapestProduct(product, description) {
    if (product.wholesaler != null) {
      let cheapestProduct = product.wholesaler.sort((a,b) => +a.price < +b.price ? -1 : 1)[0];
      this.searchValue = '';
      this.product.emit({
        'number': product.number,
        'description': description,
        'wholesaler': cheapestProduct.wholesaler.key,
        'image': product.image,
        'quantity': 1,
        'price': cheapestProduct.price,
        'listPrice': cheapestProduct.listPrice,
        'companyProduct': product.companyProduct,
        manufacturerLogo: product.manufacturerLogo,
        accountId: this.searchAccount
      })
    }
    else { this.searchValue = ''; }
  }

  closeResultBox() { this.KlarPrisClass = { 'doShow': false, 'dontShow': true } }

  updateDistributor(id, value) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    //if (id == "79F36B91-C4EE-4FE4-9872-1E70BF2E038D") { value = this.selectedPackageKpAccount; }
    //if (id == "57E26240-F5AB-45EA-B605-2B72AE37C20E") { value = this.selectedOfferKpAccount; }
    this.httpClient.put(api.jubloApi + 'api/Website/Settings/Update/' + id,
      { "value": value }, { headers }).subscribe(
        val => {
          value = val;
        },
        response => { },
        () => { }
      );
  }

  clickedOutsideOutput(event: MouseEvent) {
    if (this.searchValue != '') {
      let box :any = document.getElementById('KPOutput').getBoundingClientRect();
      if (event.clientX > box.x + box.width || event.clientX < box.x) { this.searchValue = '' }
      if (event.clientY > box.y + box.height || event.clientY < box.y) { this.searchValue = '' }
    }
  }

  klarPrisAccountChanged(event) {
    console.log(event);
    this.KlarPrisAccountChange.emit(event)
  }

  getKlarPrisSalesPrice(array: Array<string>) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.post(api.jubloApi + 'api/Website/KlarPris/GetKlarPrisSalesPrice', { array }, { headers }).subscribe(
      (data) => { },
      (response) => { console.log('KlarPris Sales Price request failed!', response, array) },
      () => { }
    )
  }

}

export class KPOfferAccount {
  companyId: string;
  companyKeyValuePairSettingsId: string;
  name: string;
  section: string;
  sort: number;
  value: string;
}

export class KlarprisResponse {
  description: string;
  image: URL;
  number: string;
  wholesaler: Array<Product>;
  companyProduct: boolean;
  productLineLength: string;
  manufacturerLogo: URL;
}

export class Product {
  highLow: number;
  listPrice: number;
  price: number;
  unit: string;
  wholesaler: KeyValuePair;
  companyProduct: boolean;
}

export class KeyValuePair {
  key: string;
  value: string;
}
